import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WidgetDetail} from '../../../../../../../domain/widget/model/widget-detail';
import {Tender, TenderStatus} from '../../../../../../../domain/funding-tender/funding-tender-data';
import {WidgetSize} from '../../../../../../../domain/widget/model/widget-size.enum';
import {TranslateService} from '@ngx-translate/core';
import {DomainUrlService} from '../../../../../../../application/config/domain-url.service';
import {UserContextService} from '../../../../../../../application/app-context/user-context/user-context.service';

@Component({
  selector: 'app-widget-funding-tender-published',
  templateUrl: './home-dashboard-widget-funding-tender-published.component.html'
})
export class HomeDashboardWidgetFundingTenderPublishedComponent implements OnInit {

  @Input() widget: WidgetDetail;
  @Input() tender: Tender;
  WidgetSize = WidgetSize;
  TenderStatus = TenderStatus;

  @Output() actionEvent = new EventEmitter<string>();

  constructor(private translateService: TranslateService,
              private domainUrlService: DomainUrlService,
              private userContextService: UserContextService) { }

  ngOnInit(): void {
  }

  public goToFundingTenderPublication(): string {
    let receiptPageUrl = this.domainUrlService.getFundingtenderUrl() + '/tender/' + this.tender.id + '/publication';
    const accountId = this.userContextService.getUserContext().accountId;
    receiptPageUrl += accountId != null ? '?accountId=' + accountId : '';
    return receiptPageUrl;
  }

}
